import { Button } from '@civilgrid/ui/components';
import { useMutation } from '@tanstack/react-query';
import { refreshTileConfig } from '~/api/internal';
import { Notify } from '~/components2/Notify';
import { MajorHeading } from '../common/Heading';

export default function RefreshTileConfig() {
  const mutation = useMutation({
    mutationKey: ['refresh-tile-config'],
    mutationFn: refreshTileConfig,
    onSuccess: (res) => {
      Notify.info({
        message: `Tile config refresh started - ${res.id}`,
      });
    },
    onError: () => {
      Notify.error({
        message: 'An error occurred while attempting to refresh tile config. Check logs for details',
      });
    },
  });

  return (
    <div>
      <MajorHeading tooltip="Refresh tile config with layer updates">Refresh tile config</MajorHeading>
      <Button
        data-testid="refresh-tile-config-button"
        onClick={() => mutation.mutate()}
        loading={mutation.isPending}
        disabled={mutation.isPending}
      >
        Refresh Tile Config
      </Button>
    </div>
  );
}
